import { render, staticRenderFns } from "./ProductCode.vue?vue&type=template&id=10642040&"
import script from "./ProductCode.vue?vue&type=script&lang=ts&"
export * from "./ProductCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports